import React from 'react'

const Resume = () => {
  return (
    <>
      <a className="resume-button" href="./ResumeOfficial.pdf" download="ResumeOfficial.pdf">My Resume (click here)</a>
      <div className='about-resume'>
            <h3>Skills</h3>
              <div className='skills'>
            const profile = <br></br>
            firstName: 'Carolina',<br></br>
            lastName: 'Vargas',<br></br>
            title: 'Full Stack Javascript Developer',<br></br>
            remotePosition: true,<br></br>
            yearsOfExperience: 'Entry Level',<br></br>
            skills = <br></br>
            ['User Authentication',<br></br>
            'React.js', <br></br>
            'Progressive Web Applications (PWAs)', <br></br>
            'Node.js', <br></br>
            'MySQL', <br></br>
            'MongoDB',<br></br>
            'MERN Stack', <br></br>
            'JavaScript', <br></br>
            'HTML', <br></br>
            'Git', <br></br>
            'Express.js', <br></br>
            'CSS',<br></br>
            'API Interactions',<br></br>
            'AJAX',]
            </div>
        </div>
    </>
  )
}

export default Resume